import { AlgoliaSearchResponse, AlgoliaSearchParams } from './algoliaClient'

/**
 * Client-side function to search via the API endpoint
 * This replaces direct Algolia client calls to keep API keys secure
 */
export const searchWithAlgoliaAPI = async ({
  query,
  page = 1,
  pageSize = 12,
}: AlgoliaSearchParams): Promise<AlgoliaSearchResponse> => {
  try {
    const searchParams = new URLSearchParams({
      query: query || '',
      page: page.toString(),
      pageSize: pageSize.toString(),
    })

    const response = await fetch(`/api/search?${searchParams.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      next: {
        revalidate: 300,
      },
    })

    if (!response.ok) {
      throw new Error(`Search API request failed: ${response.status}`)
    }

    const data: AlgoliaSearchResponse = await response.json()
    return data
  } catch (error) {
    console.error('Search API error:', error)
    throw new Error('Search failed. Please try again.')
  }
}
